(ns manage.adset-deprecated-page.view
  (:require ["@mui/material/Button$default" :as Button]
            ["src/svg/artwork/legacy.svg$default" :as Legacy]
            [common.patterns.empty-state-view :refer [empty-state-view]]
            [common.url-template :as url-tpl]
            [common.widgets.page :as page]
            [manage.adset.view.page-header :as adset-page-header]
            [reitit.frontend.easy :as rfe]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui adset-deprecated-page []
  (let [url-context (use-subscribe [:url-context])]
    (uix/use-effect (fn []
                      ;; set deprecated query-param for analytics purposes
                      (rfe/set-query (fn [query-params]
                                       (assoc query-params :deprecated true))))
                    [])
    ($ page/page
       {:title "Deprecated Adset"}
       ($ adset-page-header/page-header)
       ($ page/content-padding
          ($ empty-state-view
             {:title "This Adset is deprecated"
              :description "It looks like you're using an older adset configuration that is no longer supported. For assistance, refer to our docs or contact support. "
              :artwork Legacy
              :actions ($ Button {:type "submit"
                                  :variant "contained"
                                  :href (url-tpl/render :docs/support url-context)}
                          "Support")})))))
